import { setupFareAdapterElementForm } from '../../lib/form_helpers';

const ManagementFareAdapterConfigurationElements = {
  init() {
    setupFareAdapterElementForm();
  }
};

export default ManagementFareAdapterConfigurationElements;
